'use client';

import { useRouter } from 'next/navigation';
import { ComponentProps, useCallback, useMemo } from 'react';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import NavigationHeader from '@alltrails/layout/components/NavigationHeader';
import { getTripPlannerSearchResultHref } from '@alltrails/layout/utils/tripPlannerEntryParams';
import useMap from '@alltrails/maps/hooks/useMap';
import useAlgoliaResultSelect from '@/hooks/useAlgoliaResultSelect';

type ExploreNavigationBaseProps = ComponentProps<typeof NavigationHeader>;

const ExploreNavigationBase = (navigationHeaderProps: ExploreNavigationBaseProps) => {
  const router = useRouter();
  const languageRegionCode = useLanguageRegionCode();
  const map = useMap();
  const getMapLatLng = useMemo(() => {
    if (map) {
      return () => map.getCenter();
    }
    return undefined;
  }, [map]);

  const handleResultSelect = useAlgoliaResultSelect({ navigateToPOI: true, navigateToPlace: true, navigateToTrail: true });

  // This app owns /trip-assistant, so use client side routing
  const handleTripPlannerSelect = useCallback(() => {
    router.push(getTripPlannerSearchResultHref(languageRegionCode));
  }, [languageRegionCode, router]);

  return (
    <NavigationHeader
      searchClearOnSelect
      searchPreventNavigationOnSelect
      searchGetCurrentLatLng={getMapLatLng}
      searchOnResultSelect={handleResultSelect}
      searchOnTripPlannerSelect={handleTripPlannerSelect}
      {...navigationHeaderProps}
    />
  );
};

export default ExploreNavigationBase;
